export function formattedNumber(value, options = {}) {
  return new Intl.NumberFormat(options.locale || "ru", {
    minimumFractionDigits: options.min || 0,
    maximumFractionDigits: options.max || 2,
  }).format(value);
}
